(() => {
  if(window.ohEquipmentShopLoaded)return;
  window.ohEquipmentShopLoaded=true;
  const key = 'oh-equipment-demo-cart-v1';
  function setProductImage(img,asset,alt,base=img.src) {
    const reference=asset.startsWith('oh-xs-reference-');
    img.toggleAttribute('data-supplier-reference',reference);
    // Small OEM references retain native pixels; inflated srcset width descriptors
    // would misrepresent their resolution and change their intrinsic display size.
    if(reference) img.removeAttribute('srcset');
    else img.srcset=[640,1280,1920].map(w=>`${new URL(`${asset}-${w}.webp`,base).href} ${w}w`).join(', ');
    img.src=new URL(`${asset}-1280.webp`,base).href;
    img.alt=alt;
  }
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents/100);
  const read = () => {
    const value = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (!Array.isArray(value)) throw new Error('Invalid demo cart');
    return value.filter(item => item && typeof item.sku === 'string' && item.sku.length > 0 && item.sku.length <= 100 && !/[\x00-\x1f\x7f]/.test(item.sku) && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 10);
  };
  let knownSkus;
  let catalogRequest;
  function updateCartCounts() {
    let count;
    try {
      if (knownSkus) {
        const quantities=new Map();
        for(const item of read()) if(knownSkus.has(item.sku)) quantities.set(item.sku,Math.min(10,(quantities.get(item.sku)||0)+item.quantity));
        count=[...quantities.values()].reduce((sum,quantity)=>sum+quantity,0);
      }
    } catch { /* An unreadable cart should not be advertised as empty. */ }
    document.querySelectorAll('[data-item-cart-link]').forEach(link=>{
      let quantity=0;try{quantity=read().filter(item=>item.sku===link.dataset.itemCartLink).reduce((sum,item)=>sum+item.quantity,0);}catch{}
      link.hidden=!quantity;
      if(quantity){link.textContent=`(${quantity}) View in cart`;link.setAttribute('aria-label',`${quantity} of this option in cart. View cart`);}
    });
    // Only the offline server emits this marker. Shopify's actual cart stays native.
    if(document.body.hasAttribute('data-equipment-cart-preview')) {
      const header=document.getElementById('cart-icon-bubble');
      if(header) {
        const badge=header.querySelector('.oh-cart-count');
        if(badge){badge.hidden=count===undefined;badge.style.display=count===undefined?'none':'';badge.textContent=count===undefined?'':String(count);}
        const label=count===undefined?'Cart':`Cart, ${count} ${count===1?'item':'items'}`;
        header.setAttribute('aria-label',label);
        const accessible=header.querySelector('.visually-hidden');if(accessible)accessible.textContent=label;
      }
    }

  }
  function catalogData(url) {
    if(!catalogRequest) catalogRequest=(async()=>{
      const response=await fetch(url);
      if(!response.ok)throw new Error('Catalog unavailable');
      const {products}=await response.json();
      if(!Array.isArray(products))throw new Error('Invalid catalog');
      knownSkus=new Set(products.flatMap(p=>p.variants.map(v=>v.sku)));
      updateCartCounts();
      return products;
    })();
    return catalogRequest;
  }
  const save = items => {
    sessionStorage.setItem(key,JSON.stringify(items.map(({sku,quantity})=>({sku,quantity}))));
    updateCartCounts();
  };
  window.addEventListener('pageshow',updateCartCounts);

  async function catalog(root) {
    const filter = root.querySelector('[data-shop-filter]');
    if (!filter) return;
    const search=filter.querySelector('[data-shop-search]');
    const brand=filter.querySelector('[data-shop-brand]');
    const sort=filter.querySelector('[data-shop-sort]');
    const categories=[...filter.querySelectorAll('[data-category]')];
    const grid=root.querySelector('.oh-shop-grid');
    const cards=[...grid.children].filter(card=>card.dataset.shopCategory);
    const reviewFallback=root.querySelector('[data-shop-review-fallback]');
    if(reviewFallback) {
      for(const card of reviewFallback.querySelectorAll('[data-shop-unresolved]')) {card.hidden=true;grid.append(card);cards.push(card);}
      reviewFallback.hidden=true;
    }
    const count=root.querySelector('[data-shop-count]');
    const pager=root.querySelector('[data-shop-pagination]');
    const clear=filter.querySelector('[data-shop-clear]');
    const normalize=value=>value.toLowerCase().replace(/[^a-z0-9]+/g,'');
    let products=[];
    try {products=await catalogData(root.dataset.catalogUrl);} catch { /* Rendered details remain searchable. */ }
    const entries=cards.map((card,index)=>{
      const product=products.find(p=>p.handle===card.dataset.demoHandle);
      const unresolved=card.hasAttribute('data-shop-unresolved');
      return {card,index,title:product?.title||card.querySelector('h3').textContent,
        unresolved,
        brand:card.dataset.shopBrand,category:card.dataset.shopCategory,
        price:product?Math.min(...product.variants.map(v=>v.priceCents)):unresolved&&card.dataset.reviewPrice?Number(card.dataset.reviewPrice):null,
        search:normalize([card.textContent,product?.brand,...(product?.variants.flatMap(v=>[v.sku,...v.options])||[])].join(' '))};
    });
    if(!products.length) {sort.querySelector('[value="price-asc"]').disabled=true;sort.querySelector('[value="price-desc"]').disabled=true;}
    let category='all',page=1;
    let routeCategories=JSON.parse(root.dataset.routeCategories||'[]');
    const pageSize=12;
    const valid=(select,value)=>[...select.options].some(o=>o.value===value&&!o.disabled)?value:[...select.options].find(o=>!o.disabled).value;
    const render=()=>{
      const reviewing=category==='unresolved';
      filter.dataset.reviewMode=String(reviewing);
      brand.closest('label').hidden=reviewing;
      const reviewNote=root.querySelector('[data-shop-review-note]');if(reviewNote)reviewNote.hidden=!reviewing;
      search.placeholder=reviewing?'Item name, number or issue':'Product name or item number';
      const terms=search.value.trim().split(/\s+/).map(normalize).filter(Boolean);
      let matches=entries.filter(e=>(category==='all'?(!e.unresolved&&(!routeCategories.length||routeCategories.includes(e.category))):e.category===category)&&(reviewing||brand.value==='all'||e.brand===brand.value)&&terms.every(term=>e.search.includes(term)));
      matches.sort((a,b)=>{
        if(sort.value==='name')return a.title.localeCompare(b.title);
        if(sort.value==='price-asc'||sort.value==='price-desc') {
          if(a.price===null||b.price===null)return a.price===b.price?a.index-b.index:a.price===null?1:-1;
          return (sort.value==='price-asc'?a.price-b.price:b.price-a.price)||a.index-b.index;
        }
        return a.index-b.index;
      });
      const pages=Math.max(1,Math.ceil(matches.length/pageSize));page=Math.max(1,Math.min(page,pages));
      cards.forEach(card=>{card.hidden=true;});
      matches.forEach((e,index)=>{grid.append(e.card);e.card.hidden=index<(page-1)*pageSize||index>=page*pageSize;});
      categories.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===category)));
      const noun=reviewing?'unresolved items':'products';
      count.textContent=matches.length?`${matches.length} ${noun} · Showing ${(page-1)*pageSize+1}–${Math.min(page*pageSize,matches.length)}`:`0 ${noun}`;
      root.querySelector('[data-shop-empty]').hidden=matches.length!==0;
      clear.hidden=category==='all'&&brand.value==='all'&&!search.value;
      pager.hidden=pages===1;pager.querySelector('[data-shop-page]').textContent=`Page ${page} of ${pages}`;
      pager.querySelector('[data-shop-previous]').disabled=page===1;pager.querySelector('[data-shop-next]').disabled=page===pages;
    };
    const writeUrl=(push=false)=>{
      const url=new URL(location.href);
      if(url.pathname.startsWith('/collections/')||url.pathname==='/search')url.pathname='/collections/equipment';
      for(const [key,value,empty] of [['category',category,'all'],['brand',brand.value,'all'],['q',search.value.trim(),''],['sort',sort.value,'featured'],['page',String(page),'1']]) {
        if(value===empty)url.searchParams.delete(key);else url.searchParams.set(key,value);
      }
      if(url.href!==location.href)history[push?'pushState':'replaceState'](history.state,'',url);
    };
    const fromUrl=()=>{
      const params=new URL(location.href).searchParams;
      category=categories.some(b=>b.dataset.category===params.get('category'))?params.get('category'):'all';
      const vendorRoute=location.pathname==='/collections/vendors';
      const requestedBrand=(vendorRoute?params.get('q'):params.get('brand'))||root.dataset.routeBrand;
      if(requestedBrand&&![...brand.options].some(o=>o.value===requestedBrand))brand.add(new Option(requestedBrand,requestedBrand));
      if(vendorRoute||root.dataset.routeBrand){const heading=root.querySelector('h1');if(heading)heading.textContent=requestedBrand||'Find your next piece of kit.';root.querySelector('[data-shop-empty]').textContent=`${requestedBrand||'These'} products are not available in the online catalog yet.`;}
      brand.value=valid(brand,requestedBrand);sort.value=valid(sort,params.get('sort'));search.value=vendorRoute?'':params.get('q')||'';
      page=/^[1-9][0-9]{0,5}$/.test(params.get('page')||'')?Number(params.get('page')):1;render();
    };
    const changed=(push=true)=>{page=1;render();writeUrl(push);};
    categories.forEach(button=>button.addEventListener('click',()=>{routeCategories=[];category=button.dataset.category;changed();}));
    search.addEventListener('input',()=>changed(false));brand.addEventListener('change',()=>changed());sort.addEventListener('change',()=>changed());
    clear.addEventListener('click',()=>{routeCategories=[];category='all';brand.value='all';search.value='';sort.value='featured';changed();search.focus();});
    for(const [selector,direction] of [['[data-shop-previous]',-1],['[data-shop-next]',1]]) pager.querySelector(selector).addEventListener('click',()=>{
      page+=direction;render();writeUrl(true);count.focus({preventScroll:true});count.scrollIntoView({block:'start'});
    });
    for(const link of document.querySelectorAll('.oh-gateway-brands a'))link.addEventListener('click',event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const target=new URL(link.href);if(target.pathname!==location.pathname||target.origin!==location.origin)return;
      const selected=link.closest('[data-brand]')?.dataset.brand;if(!selected)return;
      event.preventDefault();if(![...brand.options].some(o=>o.value===selected))brand.add(new Option(selected,selected));
      brand.value=selected;changed();filter.querySelector('.oh-shop-filter').scrollIntoView({block:'start',behavior:'instant'});brand.focus({preventScroll:true});
    });
    window.addEventListener('popstate',fromUrl);fromUrl();filter.hidden=false;quickDemo(root);
  }
  async function quickDemo(root) {
    const cards = [...root.querySelectorAll('[data-demo-handle]')].filter(card=>card.dataset.demoHandle);
    if (!cards.length) return;
    let products;
    try {
      products = await catalogData(root.dataset.catalogUrl);
    } catch { return; } // Detail links remain usable if the enhancement cannot load.
    cards.forEach((card,index)=>{
      const product = products.find(p=>p.handle===card.dataset.demoHandle);
      if (!product?.variants?.length || card.querySelector('[data-demo-quick]')) return;
      const form = element('form',undefined,'oh-quick-buy');
      form.dataset.demoQuick = '';
      const label = element('label',product.optionNames.join(' / '));
      const select = element('select');
      select.id = `DemoQuick-${root.id}-${index}`; label.htmlFor = select.id;
      select.setAttribute('aria-label',`${product.optionNames.join(' / ')} for ${product.title}`);
      select.required = true;
      select.add(new Option('Choose an option',''));
      product.variants.forEach(v=>select.add(new Option(`${v.options.join(' / ')} · ${money(v.priceCents)}`,v.sku)));
      if (product.variants.length === 1) {
        select.value = product.variants[0].sku;
        label.hidden = true;
        select.hidden = true;
        form.append(element('span',product.optionNames.join(' / '),'oh-quick-option-label'),
          element('span',product.variants[0].options.join(' / '),'oh-quick-option-value'));
      }
      const button = element('button','Add to cart','oh-button'); button.type='submit';
      const actions=element('div',undefined,'oh-item-actions');
      const cartLink=element('a','','oh-item-cart-link');cartLink.href='/cart';cartLink.hidden=true;cartLink.dataset.itemCartLink='';
      actions.append(button,cartLink);
      const status = element('p','','oh-quick-status'); status.setAttribute('role','status');
      const price = card.querySelector('.oh-shop-card__price');
      if (new Set(product.variants.map(v=>v.priceCents)).size > 1) {
        price.dataset.startingPrice = `From ${money(Math.min(...product.variants.map(v=>v.priceCents)))}`;
        price.textContent = price.dataset.startingPrice;
      }
      select.addEventListener('change',()=>{
        const variant = product.variants.find(v=>v.sku===select.value);
        status.textContent = '';cartLink.dataset.itemCartLink='';cartLink.hidden=true;
        if (!variant) return;
        price.textContent = price.dataset.startingPrice || money(variant.priceCents);
        const img = card.querySelector('.oh-shop-card__image > img');
        const image = product.images.find(i=>i.asset===variant.image);
        if (img && image) {
          setProductImage(img,image.asset,image.alt);
        }
      });
      form.addEventListener('submit',event=>{
        event.preventDefault();
        if (!form.reportValidity() || !product.variants.some(v=>v.sku===select.value)) return;
        status.classList.remove('visually-hidden');
        try {
          let items; try { items=read(); } catch { items=[]; }
          const item=items.find(i=>i.sku===select.value);
          if (item?.quantity>=10) { status.textContent='The demo cart allows up to 10 of each item.'; return; }
          if (item) item.quantity++; else items.push({sku:select.value,quantity:1});
          save(items);cartLink.dataset.itemCartLink=select.value;updateCartCounts(); status.classList.add('visually-hidden'); status.textContent='Added to cart.';
        } catch { status.textContent='This browser could not save the demo cart.'; }
      });
      form.append(label,select,actions,status); card.append(form);updateCartCounts();
    });
  }
  function product(root) {
    const form = root.querySelector('[data-product-form]');
    if (!form) return;
    const variants = [...root.querySelectorAll('[data-variant-sku]')].map(row=>({sku:row.dataset.variantSku,options:[row.dataset.option1,row.dataset.option2].filter(Boolean),price:Number(row.dataset.priceCents),image:row.dataset.image,alt:row.dataset.alt}));
    if (!variants.length || variants.some(v=>!Number.isSafeInteger(v.price)||v.price<0)) return;
    const options = [...root.querySelectorAll('[data-product-option]')];
    const quantity = root.querySelector('[data-product-quantity]');
    const message = root.querySelector('[data-product-message]');
    const cartLink=root.querySelector('[data-item-cart-link]');
    const photo = root.querySelector('[data-main-photo] img');
    const original = photo.src;
    let selected;
    const showPhoto = (asset,alt) => {
      setProductImage(photo,asset,alt,original);
      root.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.photo===asset)));
    };
    options.forEach((select,index)=>{
      [...new Set(variants.map(v=>v.options[index]))].forEach(value=>select.add(new Option(value,value)));
      if (variants.length === 1) select.closest('label').hidden = true;
      select.addEventListener('change',()=>update());
    });
    const requested = new URL(location.href).searchParams.get('sku');
    const initial = variants.find(v=>v.sku===requested) || variants[0];
    options.forEach((select,index)=>{select.value=initial.options[index];});
    function update() {
      cartLink.dataset.itemCartLink='';cartLink.hidden=true;
      message.classList.remove('visually-hidden');
      selected = variants.find(v=>options.every((select,index)=>select.value===v.options[index]));
      form.querySelector('button[type=submit]').disabled = !selected;
      message.textContent = selected ? '' : 'This combination is not in this preview. Choose another option.';
      root.querySelector('[data-shop-price]').textContent = selected ? money(selected.price) : 'Choose another option';
      root.querySelector('[data-product-sku]').textContent = selected?.sku || '—';
      if (selected) showPhoto(selected.image,selected.alt);
    }
    update();
    if(requested && !variants.some(v=>v.sku===requested)) message.textContent='That item is not in this product family. The first available preview option is shown.';
    root.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>showPhoto(button.dataset.photo,button.getAttribute('aria-label'))));
    root.querySelector('[data-shop-thumbnails]').hidden=false;
    root.querySelector('[data-variant-list]').open=false;
    root.querySelector('[data-product-fallback]').hidden=true;
    form.hidden=false;
    form.addEventListener('submit',event=>{
      event.preventDefault();
      if(!selected || !form.reportValidity()) return;
      message.classList.remove('visually-hidden');
      const amount=Number(quantity.value);
      if(!Number.isInteger(amount)||amount<1||amount>10) return;
      try {
        let items;
        try {items=read();} catch {items=[];}
        const item=items.find(item=>item.sku===selected.sku);
        if((item?.quantity||0)+amount>10) {message.textContent='The demo cart allows up to 10 of each item. Adjust the quantity in your cart.';return;}
        if(item) item.quantity+=amount;else items.push({sku:selected.sku,quantity:amount});
        save(items);cartLink.dataset.itemCartLink=selected.sku;updateCartCounts();
        message.classList.add('visually-hidden');
        message.textContent=`Added ${amount} to cart.`;
      } catch {message.textContent='This browser could not save the demo cart. Product options and prices are still available here.';}
    });
  }
  const element = (tag,text,cls) => {const node=document.createElement(tag);if(text!==undefined)node.textContent=text;if(cls)node.className=cls;return node;};
  async function cart(root) {
    if(!root.querySelector('[data-cart-loading]')) return;
    const status=root.querySelector('[data-cart-status]');
    const container=root.querySelector('[data-cart-items]');
    const review=root.querySelector('[data-cart-review]');
    const loading=root.querySelector('[data-cart-loading]');
    let products;
    try {
      products=await catalogData(root.dataset.catalogUrl);
    } catch {loading.textContent='The demo catalog could not load. Refresh to try again; no order or payment has been made.';return;}
    const bySku=new Map(products.flatMap(p=>p.variants.map(v=>[v.sku,{...v,product:p}])));
    let items;
    try {items=read();}catch {items=[];status.textContent='The saved demo cart could not be read. Start a new selection.';}
    // Reconcile stale or altered storage against authoritative local catalog prices.
    const clean=new Map();
    for(const item of items) if(bySku.has(item.sku))clean.set(item.sku,{sku:item.sku,quantity:Math.min(10,(clean.get(item.sku)?.quantity||0)+item.quantity)});
    items=[...clean.values()];loading.hidden=true;
    function persist(){try{save(items);}catch{status.textContent='Changes could not be saved in this browser.';}}
    function render() {
      container.replaceChildren();review.hidden=!items.length;
      if(!items.length){container.append(element('p','Your demo cart is empty. Choose equipment to try a purchase.'));return;}
      let total=0;
      for(const item of items) {
        const v=bySku.get(item.sku);total+=v.priceCents*item.quantity;
        const row=element('article',undefined,'oh-shop-cart-row');
        const text=element('div');const link=element('a',v.product.title,'oh-text-link');
        link.href=`${root.dataset.root}pages/${encodeURIComponent(v.product.handle)}?sku=${encodeURIComponent(item.sku)}#equipment-product`;
        text.append(link,element('p',v.options.join(' / ')),element('p',`${item.sku} · ${money(v.priceCents)} each`,'oh-shop-note'));
        const controls=element('div',undefined,'oh-shop-cart-controls');
        const label=element('label',`Quantity for ${v.product.title} (${v.options.join(' / ')})`);const select=element('select');
        for(let i=1;i<=10;i++)select.add(new Option(String(i),String(i)));select.value=String(item.quantity);label.append(select);
        const subtotal=element('strong',money(v.priceCents*item.quantity));
        select.addEventListener('change',()=>{item.quantity=Number(select.value);persist();subtotal.textContent=money(v.priceCents*item.quantity);updateTotal();});
        const remove=element('button','Remove','oh-text-link');remove.type='button';remove.setAttribute('aria-label',`Remove ${v.product.title} (${v.options.join(' / ')})`);
        remove.addEventListener('click',()=>{items=items.filter(x=>x!==item);persist();render();status.textContent=`Removed ${v.product.title}.`;status.focus();});
        controls.append(label,subtotal,remove);row.append(text,controls);container.append(row);
      }
      root.querySelector('[data-cart-total]').textContent=money(total);
    }
    function updateTotal(){root.querySelector('[data-cart-total]').textContent=money(items.reduce((n,i)=>n+bySku.get(i.sku).priceCents*i.quantity,0));}
    root.querySelector('[data-cart-checkout]').addEventListener('click',()=>{
      if(!items.length)return;
      items=[];persist();container.hidden=true;review.hidden=true;
      const done=root.querySelector('[data-cart-complete]');done.hidden=false;done.querySelector('h2').focus();
    });
    render();
  }
  function setup(scope) {
    const source=[...scope.querySelectorAll('[data-catalog-url]')].find(root=>
      !root.matches('[data-equipment-catalog]') || root.querySelector('[data-shop-filter]'));
    if(source)catalogData(source.dataset.catalogUrl).catch(()=>{});
    updateCartCounts();
    for(const [selector,init] of [['[data-equipment-catalog]',catalog],['[data-equipment-product]',product],['[data-equipment-cart]',cart]]) {
      scope.querySelectorAll(selector).forEach(root=>{if(root.dataset.shopReady)return;root.dataset.shopReady='true';init(root);});
    }
  }
  setup(document);document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
